
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/lineup",
      function () {
        return require("private-next-pages/festivals/[festivalId]/lineup.tsx");
      }
    ]);
  